module.exports = __webpack_public_path__ + "static/media/purple-bottle.4e5beb4d.svg";